import * as yup from "yup";
import { t } from "i18next";

export const getSmsCodeSchema = () => {
  return yup.object({
    code: yup.string().required(t("validation.required")),
  });
};
